import { useEffect, useState } from "react";
export default function useDelay(delay = 2000) {
  const [done, setDone] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDone(true);
    }, [delay]);
    return () => clearTimeout(timer);
  }, []);
  return {
    done,
  };
}
